import { render, staticRenderFns } from "./paimingqingkuang.vue?vue&type=template&id=732f5b5a&scoped=true"
import script from "./paimingqingkuang.vue?vue&type=script&lang=js"
export * from "./paimingqingkuang.vue?vue&type=script&lang=js"
import style0 from "./paimingqingkuang.vue?vue&type=style&index=0&id=732f5b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732f5b5a",
  null
  
)

export default component.exports